import React from 'react';
import { getIconMethodByType, MENU_PAY_ON_DELIVERY, MENU_PREPAID, METHOD_PAYMENT_TYPE_MONEY } from '../../../Utils/Constants/Checkout';
import { useTranslation } from 'react-i18next';
import MenuPaymentMethods from './MenuPaymentMethods';
import { useCheckoutContext } from '../../../Contexts/CheckoutContext';
import ButtonPaymentMethod from '../../Form/ButtonPaymentMethod';
import { useOrderTypeContext } from '../../../Contexts/OrderTypeContext';
import { ORDER_TYPE_STORE_COUNTER } from '../../../Utils/Constants/Service';
import BadgeChangeAmount from './BadgeChangeAmount';

interface PaymentMethodsProps {    
    cart: any;
    prepaidList: any;
    payOnDeliveryList: any;
    onChangeMethod: CallableFunction;
    customerCards: any;
    loading: boolean;
    isNewCardEnabled: boolean;
}
const PaymentMethods = ({ 
        cart, onChangeMethod, customerCards, loading, prepaidList, payOnDeliveryList, isNewCardEnabled 
    }: PaymentMethodsProps) => {

    const { t } = useTranslation();
    const { currentCard, paymentMethod, setPaymentMethod, currentMenuMethod, setCurrentMenuMethod, methodCardOnline, showRegisterCard, setShowRegisterCard, setShowConfirmChangeAmount } = useCheckoutContext();
    const { orderType } = useOrderTypeContext();

    const handleChangeMethodCard = () => {
        setShowRegisterCard(true);
        setPaymentMethod(methodCardOnline);
    }

    return (
        <div className='grid gap-6 p-4 pt-2'>
            {/* //! hasPayOnDelivery com o store_counter fixado TEMPORARIAMENTE */}
            <MenuPaymentMethods
                loading={loading}
                current={currentMenuMethod}
                onClick={(e: number) => setCurrentMenuMethod(e)}
                hasPrepaid={loading || prepaidList.length > 0 || isNewCardEnabled || (customerCards && customerCards.length > 0)}
                hasPayOnDelivery={orderType !== ORDER_TYPE_STORE_COUNTER && (loading || payOnDeliveryList.length > 0)}
            />

            <nav className={`flex flex-col gap-2 w-full ${cart.empty || cart.total === 0 ? 'grayscale pointer-events-none' : ''}`}>

                {/* Prepaid */}
                {(currentMenuMethod === MENU_PREPAID && prepaidList.length > 0) &&
                    <>
                        {prepaidList
                            .filter((method: any) => method.visible)
                            .map((method: any, index: number) =>
                                <ButtonPaymentMethod
                                    onClick={() => onChangeMethod(method)}
                                    label={t('checkout.button_method_payment_label')}
                                    title={method.name}
                                    image_url={method.image_url ?? ''}
                                    active={paymentMethod?.type === method.type}
                                    disabled={paymentMethod?.type === method.type}
                                    key={index}
                                    loading={loading}
                                />
                            )}
                    </>
                }

                {/* Customer cards */}
                {(customerCards && currentMenuMethod === MENU_PREPAID) &&
                    customerCards.map((card: any, index: number) =>
                        <ButtonPaymentMethod
                            label={t('checkout.button_method_payment_my_card_label')}
                            title={card.brand}
                            payCard={!Boolean(card.brand_image)}
                            image_url={card.brand_image.toLowerCase() ?? ''}
                            active={paymentMethod?.id === card.id}
                            onClick={() => onChangeMethod(card)}
                            className="relative"
                            loading={loading}
                            number={card.masked_number.slice(-4)}
                            main={card.main}
                            key={index}
                        />
                    )
                }

                {/* New customer card */}
                {(isNewCardEnabled && currentMenuMethod === MENU_PREPAID) &&
                    <ButtonPaymentMethod
                        add
                        label={customerCards?.length > 0 ? t('checkout.button_method_payment_other_card_label') : t('checkout.button_method_payment_label')}
                        title={t('checkout.button_method_payment_card_label')}
                        active={paymentMethod?.type === methodCardOnline?.type && paymentMethod?.register}
                        disabled={showRegisterCard}
                        onClick={handleChangeMethodCard}
                        className="relative"
                        loading={loading}
                        number={currentCard?.number?.slice(-4)}
                        editButton={Boolean(currentCard)}
                    />
                }

                {/* Pay on delivery com sub methods */}
                {(payOnDeliveryList.length > 0 && currentMenuMethod === MENU_PAY_ON_DELIVERY) &&
                    <>
                        {payOnDeliveryList
                            .filter((method: any) => method.visible)
                            .map((method: any, index: number) => {
                                const isMethodMoney = method?.type === METHOD_PAYMENT_TYPE_MONEY;
                                const hasCashAmount = isMethodMoney && paymentMethod?.cash_amount > 0;
                                return (
                                    method.methods && method.methods.length > 0 
                                        ? 
                                            method.methods.map((subMethod: any, subIndex: number) =>
                                                <ButtonPaymentMethod
                                                    onClick={() => hasCashAmount ? setShowConfirmChangeAmount(true) : onChangeMethod(subMethod)}
                                                    label={t('checkout.button_method_payment_label')}
                                                    title={subMethod.name}
                                                    icon={!subMethod.image_url || subMethod.image_url === '' ? getIconMethodByType(method.type, 35) : ''}
                                                    payMoney={subMethod.type === METHOD_PAYMENT_TYPE_MONEY}
                                                    image_url={subMethod.image_url ?? ''}
                                                    active={paymentMethod?.id === subMethod.id}
                                                    disabled={!isMethodMoney && paymentMethod?.id === subMethod.id}
                                                    key={`${index}-${subIndex}`}
                                                    loading={loading}
                                                >
                                                    <BadgeChangeAmount method={subMethod} />
                                                </ButtonPaymentMethod>
                                            )
                                        :
                                            <ButtonPaymentMethod
                                                onClick={() => hasCashAmount ? setShowConfirmChangeAmount(true) : onChangeMethod(method)}
                                                label={t('checkout.button_method_payment_label')}
                                                title={method.name}
                                                icon={getIconMethodByType(method.type, 35)}
                                                image_url={(method.type !== METHOD_PAYMENT_TYPE_MONEY && method.image_url) ?? ''}
                                                active={paymentMethod?.type === method.type}
                                                disabled={!isMethodMoney && paymentMethod?.id === method.id}
                                                key={index}
                                                loading={loading}
                                            >
                                                {/* Troco */}
                                                <BadgeChangeAmount method={method} />
                                            </ButtonPaymentMethod>
                                    )
                                }
                            )}
                    </>
                }

            </nav>
        </div>
    )
};

export default PaymentMethods;
